export default "__VITE_ASSET__5bcf5e6b__"